{
  "valid": "Дійсний"
}
